import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {HttpClient} from "@angular/common/http";
import {appConfig} from '../app.config';
import {SellerLocation} from "../domain/item";


@Injectable({
  providedIn: 'root'
})

export class AssetLocationService {

  private readonly saveLocationUrl = '/api/save-asset-location';

  constructor(private http: HttpClient) {}

  public saveLocation(assetLocation: SellerLocation): Observable<any> {
    return this.http.post<any>(this.saveLocationUrl, assetLocation, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetLocation', false))
      );
  }
}
